import api, { adminApi, riderApi, sellerApi } from "./api";

export const loginApi = async ({ usernameOrEmail, password }) => {
  const res = await api.post(
    "/api/v1/auth/login",
    { usernameOrEmail, password },
    { skipAuth: true }
  );
  return res.data;
};

export const sellerLoginApi = async ({ usernameOrEmail, password }) => {
  const res = await api.post(
    "/api/v1/auth/seller/login",
    { usernameOrEmail, password },
    { skipAuth: true }
  );
  return res.data;
};

export const adminLoginApi = async ({ usernameOrEmail, password }) => {
  const res = await api.post(
    "/api/v1/auth/admin/login",
    { usernameOrEmail, password },
    { skipAuth: true }
  );
  return res.data;
};

export const getAdminProfileApi = async () => {
  const res = await adminApi.get("/api/v1/auth/admin/profile");
  return res.data;
};

export const getSellerProfileApi = async () => {
  const res = await sellerApi.get("/api/v1/auth/seller/profile");
  return res.data;
};

export const logoutApi = async () => {
  const res = await api.post("/api/v1/auth/logout");
  return res.data;
};

export const registerApi = async (payload) => {
  const res = await api.post("/api/v1/auth/register", payload, {
    skipAuth: true,
  });
  return res.data;
};

export const sellerRegisterApi = async (payload) => {
  // ถ้าเป็น FormData ให้ไม่ set Content-Type header (ให้ browser set ให้เอง)
  const config = {
    skipAuth: true,
  };
  
  if (payload instanceof FormData) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };
  }
  
  const res = await api.post("/api/v1/auth/seller/register", payload, config);
  return res.data;
};

export const riderLoginApi = async ({ usernameOrEmail, password }) => {
  const res = await api.post(
    "/api/v1/auth/rider/login",
    { usernameOrEmail, password },
    { skipAuth: true }
  );
  return res.data;
};

export const riderRegisterApi = async (payload) => {
  // ถ้าเป็น FormData ให้ไม่ set Content-Type header (ให้ browser set ให้เอง)
  const config = {
    skipAuth: true,
  };
  
  if (payload instanceof FormData) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };
  }
  
  const res = await api.post("/api/v1/auth/rider/register", payload, config);
  return res.data;
};

export const getRiderProfileApi = async () => {
  const res = await riderApi.get("/api/v1/auth/rider/profile");
  return res.data;
};

export const updateRiderProfileApi = async (data) => {
  const res = await riderApi.put("/api/v1/auth/rider/profile", data);
  return res.data;
};

export const updateRiderProfileImageApi = async (formData) => {
  const res = await riderApi.put("/api/v1/auth/rider/profile/image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const changeRiderPasswordApi = async (data) => {
  const res = await riderApi.put("/api/v1/auth/rider/password", data);
  return res.data;
};

// Forgot password - request reset code/link
// NOTE: ปรับ endpoint ตาม backend ของคุณได้เลยถ้าไม่ใช่ URL นี้
export const forgotPasswordRequestApi = async (email) => {
  const res = await api.post(
    "/api/v1/auth/forgot-password",
    { email },
    { skipAuth: true }
  );
  return res.data;
};

// Forgot password - verify OTP code
// NOTE: ปรับ endpoint/payload ตาม backend ของคุณได้เลยถ้าไม่ใช่รูปแบบนี้
export const forgotPasswordVerifyOtpApi = async ({ email, code }) => {
  const res = await api.post(
    "/api/v1/auth/forgot-password/verify",
    { email, code },
    { skipAuth: true }
  );
  return res.data;
};

// Forgot password - reset password
// NOTE: ปรับ endpoint/payload ตาม backend ของคุณได้เลยถ้าไม่ใช่รูปแบบนี้
export const forgotPasswordResetPasswordApi = async ({
  email,
  code,
  newPassword,
}) => {
  const res = await api.post(
    "/api/v1/auth/forgot-password/reset-password",
    { email, code, newPassword },
    { skipAuth: true }
  );
  return res.data;
};